export class API{
    public static prodBaseURL = "https://galaxy-test-api.clevernav.ai";
}